export const environment = {
  baseUrl: 'https://quiz.dev.aodocs.app',
  apiUrl: '/_ah/api/',
  aodocsUrl: 'https://staging-usc1.aodocs.app/',
  clientId: '481824967233-lqr09vdfu8hvc823pqf66rbkb0ad9ug9.apps.googleusercontent.com',
  version: '1.0.0',
  production: true
};
